import { concat, fn, hash } from "@ember/helper";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import { or } from "truth-helpers";
import DButton from "discourse/components/d-button";
import concatClass from "discourse/helpers/concat-class";
import icon from "discourse-common/helpers/d-icon";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
import templateOnly from "@ember/component/template-only";
const DDefaultToast = setComponentTemplate(createTemplateFactory(
/*
  
  <div
    class={{concatClass
      "fk-d-default-toast"
      (concat "-" (or @data.theme "default"))
    }}
    ...attributes
  >
    {{#if @showProgressBar}}
      <div
        class="fk-d-default-toast__progress-bar"
        {{didInsert @onRegisterProgressBar}}
      ></div>
    {{/if}}
    {{#if @data.icon}}
      <div class="fk-d-default-toast__icon-container">
        {{icon @data.icon}}
      </div>
    {{/if}}
    <div class="fk-d-default-toast__main-container">
      <div class="fk-d-default-toast__texts">
        {{#if @data.title}}
          <div class="fk-d-default-toast__title">
            {{@data.title}}
          </div>
        {{/if}}
        {{#if @data.message}}
          <div class="fk-d-default-toast__message">
            {{@data.message}}
          </div>
        {{/if}}
      </div>

      {{#if @data.actions}}
        <div class="fk-d-default-toast__actions">
          {{#each @data.actions as |toastAction|}}
            {{#if toastAction.action}}
              <DButton
                @icon={{toastAction.icon}}
                @translatedLabel={{toastAction.label}}
                @action={{fn toastAction.action (hash data=@data close=@close)}}
                class={{toastAction.class}}
                tabindex="0"
              />
            {{/if}}
          {{/each}}
        </div>
      {{/if}}
    </div>
    <div class="fk-d-default-toast__close-container">
      <DButton class="btn-transparent" @icon="times" @action={{@close}} />
    </div>
  </div>

*/
{
  "id": "FuXYWt8k",
  "block": "[[[1,\"\\n  \"],[11,0],[16,0,[28,[32,0],[\"fk-d-default-toast\",[28,[32,1],[\"-\",[28,[32,2],[[30,1,[\"theme\"]],\"default\"],null]],null]],null]],[17,2],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[11,0],[24,0,\"fk-d-default-toast__progress-bar\"],[4,[32,3],[[30,4]],null],[12],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"icon\"]],[[[1,\"      \"],[10,0],[14,0,\"fk-d-default-toast__icon-container\"],[12],[1,\"\\n        \"],[1,[28,[32,4],[[30,1,[\"icon\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[10,0],[14,0,\"fk-d-default-toast__main-container\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"fk-d-default-toast__texts\"],[12],[1,\"\\n\"],[41,[30,1,[\"title\"]],[[[1,\"          \"],[10,0],[14,0,\"fk-d-default-toast__title\"],[12],[1,\"\\n            \"],[1,[30,1,[\"title\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,1,[\"message\"]],[[[1,\"          \"],[10,0],[14,0,\"fk-d-default-toast__message\"],[12],[1,\"\\n            \"],[1,[30,1,[\"message\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n\"],[41,[30,1,[\"actions\"]],[[[1,\"        \"],[10,0],[14,0,\"fk-d-default-toast__actions\"],[12],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,1,[\"actions\"]]],null]],null],null,[[[41,[30,5,[\"action\"]],[[[1,\"              \"],[8,[32,5],[[16,0,[30,5,[\"class\"]]],[24,\"tabindex\",\"0\"]],[[\"@icon\",\"@translatedLabel\",\"@action\"],[[30,5,[\"icon\"]],[30,5,[\"label\"]],[28,[32,6],[[30,5,[\"action\"]],[28,[32,7],null,[[\"data\",\"close\"],[[30,1],[30,6]]]]],null]]],null],[1,\"\\n\"]],[]],null]],[5]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"fk-d-default-toast__close-container\"],[12],[1,\"\\n      \"],[8,[32,5],[[24,0,\"btn-transparent\"]],[[\"@icon\",\"@action\"],[\"times\",[30,6]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[\"@data\",\"&attrs\",\"@showProgressBar\",\"@onRegisterProgressBar\",\"toastAction\",\"@close\"],false,[\"if\",\"each\",\"-track-array\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/float-kit.d0433c99/node_modules/float-kit/components/d-default-toast.js",
  "scope": () => [concatClass, concat, or, didInsert, icon, DButton, fn, hash],
  "isStrictMode": true
}), templateOnly());
export default DDefaultToast;